import { Card } from "@components/cards/card";
import { RenderYouTubeVideo } from "@components/videos/Youtube";
import {
  IRaffleDefaultRewardMediaDTO,
  IRaffleDefaultRewardDTO,
} from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import { useEffect, useState } from "react";
import ReactImageGallery from "react-image-gallery";
import DOMPurify from "dompurify";
import "react-image-gallery/styles/css/image-gallery.css";
import { ModalAddBalance } from "@components/modals/modal-add-balance";

interface IProps {
  reward: IRaffleDefaultRewardDTO | undefined;
}

interface IReactImageGalleryDTO {
  original: string;
  thumbnail: string;
  descripition?: string;
  embedUrl?: string;
  renderItem?: any;
}

export function RaffleDefaultNumberRewardInfo({ reward }: IProps) {
  const [images, setImages] = useState<IReactImageGalleryDTO[]>([]);

  const policy = window.trustedTypes?.createPolicy("sanitize-html", {
    createHTML: (input) => DOMPurify.sanitize(input),
  });

  useEffect(() => {
    if (reward) {
      const thumb = reward.thumb
        ? {
            original: String(`${reward.thumb}`),
            thumbnail: String(`${reward.thumb}`),
          }
        : null;

      const medias =
        reward?.medias && Array.isArray(reward.medias)
          ? reward.medias.map((media: IRaffleDefaultRewardMediaDTO) => {
              // --- If render a Video --- //
              if (media.type === "video") {
                return {
                  original: `https://img.youtube.com/vi/${media.url}/hqdefault.jpg`,
                  embedUrl: `https://www.youtube.com/embed/${media.url}`,
                  description: media?.description || undefined,
                  thumbnail: `https://img.youtube.com/vi/${media.url}/default.jpg`,
                  renderItem: () => (
                    <RenderYouTubeVideo
                      embedUrl={`https://www.youtube.com/embed/${media.url}?rel=0`}
                    />
                  ),
                };
              }

              // --- If render a Image --- //
              return {
                original: String(`${media.url}`),
                thumbnail: String(`${media.url}`),
                description: media?.description || undefined,
              };
            })
          : [];

      const gallery = thumb ? [thumb, ...medias] : medias;

      setImages(gallery);
    }
  }, [reward]);

  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <Card className="mx-5">
            <div className="card-header pt-2 pb-0 d-flex flex-column justify-content-center align-items-center">
              <div className="h5 fw-bold">{reward?.name || `Sem nome`}</div>
            </div>
            <div className={`card-body pt-2`}>
              {/* Media Galleries */}
              <div className="row">
                <ReactImageGallery
                  items={images}
                  showBullets
                  showPlayButton={false}
                  showFullscreenButton={false}
                  thumbnailPosition="bottom"
                  additionalClass="react-image-gallery-lib"
                />
              </div>

              {/* Texts: Name, Descriptions, etc */}
              <div className="row mt-4">
                <div className="col-md-12">
                  <div className="text-center mb-1">
                    <span className="fw-bold h5">{`Descrição`}</span>
                  </div>
                </div>

                <hr />

                <div className="text-center mb-3">
                  <span>
                    {reward?.description_short || `Sem descrição resumida`}
                  </span>
                </div>

                <hr />

                <div>
                  <span
                    dangerouslySetInnerHTML={{
                      __html:
                        policy?.createHTML(
                          reward?.description || "Sem descrição"
                        ) || "Sem descrição",
                    }}
                  />
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
